import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Progress from 'components/common/Progress';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { hasSubmitSucceeded, reset, submit, destroy } from 'redux-form';

import { clearPrescribersRegistry } from 'redux/modules/prescribersRegistry';

import Button from 'components/common/Button';

import PrescribersSearchDialogFilterForm from './PrescribersSearchDialogFilterForm';
import PrescribersSearchDialogList from './PrescribersSearchDialogList';

const styles = () => ({
  action: {
    '&:first-child': {
      position: 'absolute',
      left: 14,
      top: 8,
    },
  },
});

class PrescribersSearchDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      entered: false,
    };

    this.onDialogEntered = this.onDialogEntered.bind(this);
    this.onDialogExited = this.onDialogExited.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { initialValues, actions, form } = this.props;
    if (nextProps.initialValues && initialValues &&
      (nextProps.initialValues['First Name'] !== initialValues['First Name']
      || nextProps.initialValues['Last Name'] !== initialValues['Last Name']
      || nextProps.initialValues.NPI !== initialValues.NPI)) {
      actions.destroy(form);
    }
  }

  onDialogEntered() {
    const { form, clearOnOpen, actions, initialValues } = this.props;
    if (initialValues !== null) {
      actions.submit(form);
    } else if (clearOnOpen) {
      actions.clearPrescribersRegistry();
      actions.reset(form);
    }
    this.setState({ entered: true });
  }

  onDialogExited() {
    const { form, actions } = this.props;
    this.setState({ entered: false });
    actions.reset(form);
  }

  render() {
    const {
      form,
      open,
      onClose,
      title,
      prescribersRegistry,
      onPrescriberSelect,
      loading,
      submitSucceeded,
      initialValues,
      classes,
    } = this.props;
    const { entered } = this.state;
    return (
      <Dialog
        open={open}
        onClose={onClose}
        onEntered={this.onDialogEntered}
        onExited={this.onDialogExited}
        maxWidth="md"
      >
        <DialogTitle onCloseClick={onClose}>
          <Typography
            variant="title"
            color="secondary"
            align="center"
          >
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent
          withScrollbars
          disableGutters
          fullHeight
        >
          <PrescribersSearchDialogFilterForm
            form={form}
            initialValues={initialValues}
            destroyOnUnmount={false}
          />
          {(loading > 0 || !entered) ? (
            <Progress />
          ) : (
            <PrescribersSearchDialogList
              prescribers={prescribersRegistry}
              onPrescriberClick={prescriber => onPrescriberSelect(prescriber)}
              submitSucceeded={submitSucceeded}
            />
          )}
        </DialogContent>
        {!initialValues &&
          <DialogActions>       
            <Button
              onClick={() => onPrescriberSelect()}
              variant="raised"
            >
              Skip and create new
            </Button>
          </DialogActions>
        }
      </Dialog>
    );
  }
}

PrescribersSearchDialog.propTypes = {
  prescribersRegistry: PropTypes.arrayOf(PropTypes.shape({
    npi: PropTypes.number.isRequired,
  })).isRequired,
  form: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  loading: PropTypes.number.isRequired,
  onPrescriberSelect: PropTypes.func,
  submitSucceeded: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    clearPrescribersRegistry: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    destroy: PropTypes.func.isRequired,
  }).isRequired,
  clearOnOpen: PropTypes.bool,
  initialValues: PropTypes.shape({
    'First Name': PropTypes.string,
    'Last Name': PropTypes.string,
    NPI: PropTypes.string,
  }),
  classes: PropTypes.shape({
    action: PropTypes.string.isRequired,
  }).isRequired,
};

PrescribersSearchDialog.defaultProps = {
  clearOnOpen: true,
  open: false,
  title: 'Find Prescriber in Registry',
  initialValues: null,
  onClose: () => {},
  onPrescriberSelect: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  prescribersRegistry: store.prescribersRegistry.data,
  loading: store.prescribersRegistry.loading,
  submitSucceeded: hasSubmitSucceeded(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    clearPrescribersRegistry,
    reset,
    submit,
    destroy,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(PrescribersSearchDialog),
);



// WEBPACK FOOTER //
// ./src/components/settings/PrescribersSearchDialog/PrescribersSearchDialog.js